import React, { FunctionComponent, useState } from 'react';
import { useScreenSize } from '../../../hooks/useScreenSize';
import { SanityNavItem } from '../../../types/common';
import { DownIcon } from '../../Icons';
import NavLink from '../../NavLink';

type NavItemProps = {
  item: SanityNavItem;
};

const NavItem: FunctionComponent<NavItemProps> = ({ item }) => {
  const [open, setOpen] = useState(false)
  const { isMobile } = useScreenSize();

  if (item.navL2.length > 0) {
    if (isMobile) {
      return (
        <>
          {item.navL2.map((item) => (
            <li key={item._key}>
              <NavLink data={item} icon />
            </li>
          ))}
        </>
      )
    }

    return (
      <div className={`dropdown ${open ? 'open' : ''}`}>
        <button onClick={() => setOpen(prevState => !prevState)}>
          {item.navL1.name}
          <DownIcon />
        </button>
        <ul className='dropdown-level2'>
          {item.navL2.map((item) => (
            <li key={item._key}>
              <NavLink data={item} icon />
            </li>
          ))}
        </ul>
      </div>
    )
  }

  return (
    <li>
      <NavLink data={item.navL1} icon />
    </li>
  )
};

export default NavItem;
